import { render, staticRenderFns } from "./ApproveProfile.vue?vue&type=template&id=41995cc1&scoped=true&"
import script from "./ApproveProfile.vue?vue&type=script&lang=js&"
export * from "./ApproveProfile.vue?vue&type=script&lang=js&"
import style0 from "./ApproveProfile.vue?vue&type=style&index=0&id=41995cc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41995cc1",
  null
  
)

export default component.exports